export const COMPANY_PHONE_LOCAL = '16206243';
export const COMPANY_PHONE_DISPLAY = '+44 162 06243';
export const COMPANY_PHONE_TEL = 'tel:+4416206243';
export const COMPANY_WHATSAPP_DISPLAY = '+44 7985422777';
export const COMPANY_WHATSAPP_LINK = 'https://wa.me/+447985422777';
export const COMPANY_EMAIL = 'info@wejoiner.com';
export const COMPANY_EMAIL_MAILTO = 'mailto:info@wejoiner.com';
export const COMPANY_ADDRESS_I18N_KEY = 'aboutUs.contactData.addressValue';
